import { CheckCircle2, DoorOpen, Users } from "lucide-react";
import React from "react";

const brl = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

// Faixa em cima dos produtos do Fechar mesa: um botão por pessoa com o que
// ela ainda deve. Tocar marca os produtos dela (e só os dela); "Mesa" marca o
// que foi lançado sem dono. Quem já pagou tudo e ainda não saiu tem o botão
// de dar a saída (pessoa criada no painel não tem celular para o QR) — só com
// o "pagamento na mesa" ligado em Preferências. Com tudo
// pago (pelo celular), "Encerrar a mesa" fecha sem cobrar nada. Só aparece
// quando a mesa tem pessoas do QR ou criadas pelo garçom.
export default function PagarPorPessoa({ cobranca, itens, divisaoAtiva, onEncerrar }) {
  const { pessoas, pessoaId, escolher, darSaida, setDarSaida, darSaidaDireto, donoDe, saidaLigada, SEM_DONO } = cobranca;
  if (!pessoas.length || divisaoAtiva) return null;
  const semDono = itens.filter((i) => !i._paid && !donoDe(i)).length;
  const escolhida = pessoas.find((p) => p.cliente_id === pessoaId);
  const tudoPago = itens.length > 0 && itens.every((i) => i._paid);

  const chip = (id, rotulo, detalhe, apagado, acao) => (
    <button
      key={id}
      type="button"
      onClick={acao || (() => escolher(id))}
      disabled={apagado}
      data-e2e="cobrar-pessoa"
      className={`shrink-0 rounded-full border px-3 py-1.5 text-xs font-bold transition-colors disabled:opacity-40 ${
        pessoaId === id ? "bg-primary text-primary-foreground border-primary" : "bg-background hover:bg-muted"
      }`}
    >
      {rotulo} <span className="font-normal opacity-80 tabular-nums">{detalhe}</span>
    </button>
  );

  const chipDaPessoa = (p) => {
    const nome = p.primeiro_nome || p.nome;
    // Saiu e ainda deve (ex.: o pagamento dela foi apagado depois da saída):
    // continua dando para cobrar
    if (p.saiu && p.restante > 0) return chip(p.cliente_id, nome, `saiu · ${brl(p.restante)}`, false);
    if (p.saiu) return chip(p.cliente_id, nome, "saiu", true);
    if (p.restante > 0) return chip(p.cliente_id, nome, brl(p.restante), false);
    // Sem o pagamento na mesa ligado não há saída pelo QR: só mostra que pagou
    if (!saidaLigada) return chip(p.cliente_id, nome, "pago", true);
    return chip(p.cliente_id, nome, "pago · dar saída", false, () => darSaidaDireto(p));
  };

  return (
    <div className="-mx-3 -mt-3 mb-3 px-3 py-2 border-b bg-muted/30 space-y-2" data-e2e="cobrar-por-pessoa">
      <p className="text-[11px] font-semibold text-muted-foreground flex items-center gap-1.5">
        <Users className="w-3.5 h-3.5" /> Cobrar por pessoa
      </p>
      <div className="flex gap-1.5 overflow-x-auto pb-0.5">
        {pessoas.map(chipDaPessoa)}
        {semDono ? chip(SEM_DONO, "Mesa", `${semDono} item(ns)`, false) : null}
      </div>
      {escolhida && saidaLigada ? (
        <label className="flex items-center gap-2 text-xs cursor-pointer select-none">
          <input type="checkbox" checked={darSaida} onChange={(e) => setDarSaida(e.target.checked)} data-e2e="cobrar-dar-saida" />
          <DoorOpen className="w-3.5 h-3.5" /> Dar a saída de {escolhida.primeiro_nome || escolhida.nome} ao confirmar
        </label>
      ) : null}
      {tudoPago && onEncerrar ? (
        <button type="button" onClick={onEncerrar} data-e2e="encerrar-mesa-paga"
          className="w-full h-10 rounded-lg bg-emerald-600 text-white text-sm font-bold flex items-center justify-center gap-1.5">
          <CheckCircle2 className="w-4 h-4" /> Tudo pago — encerrar a mesa
        </button>
      ) : null}
    </div>
  );
}
